import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
  AfterViewInit,
  OnDestroy,
  ViewEncapsulation
} from '@angular/core';
import { DatePipe } from '@angular/common';
import $, { type } from 'jquery';

import { GridOption, defaultGridOption, GridItem, GridColumn, GridExternalFilter } from './grid-control.model';

import { UtilityService } from '../../services/utility/utility.service';
import { ConfigurationService } from '../../services/configuration/configuration.service';

import { ApiService } from '../../services/api/api.service';
import { ExcelService } from '../../services/excel/excel.service';
import { NotifyService } from '../../services/notify/notify.service';
import { IHandlerServer, IHandlerLocal } from './handlers/handler';
import { HandlerLocal } from './handlers/handler-local';
import { HandlerDotnet } from './handlers/handler-dotnet';
import { ConfigResult } from './components/grid-config/grid-config.model';
import { GridConfigComponent } from './components/grid-config/grid-config.component';
import { EditorHandlerPipe } from './pipes/editor-handler.pipe';
import { GridPopupEditorComponent } from './components/grid-popup-editor/grid-popup-editor.component';
import { GridPopupFilterComponent } from './components/grid-popup-filter/grid-popup-filter.component';
import { GridImportExcelComponent } from './components/grid-import-excel/grid-import-excel.component';
import { Subscription } from 'rxjs';
import { ExcelConfig, ExcelTempateColumn } from '../../services/excel/excel.model';
import { GridPopupExportExcelComponent } from './components/grid-popup-export-excel/grid-popup-export-excel.component';
import { QuickFilter, FilterConfiguration } from './components/grid-popup-filter/grid-popup-filter.model';
import { MatSelectChange, MatSelect } from '@angular/material/select';
import { LoadingService } from '../../services/loading/loading.service';
import { FilterInfo } from './models/filter-info.model';
import { TranslateService } from '../../services/translate/translate.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { IfStmt } from '@angular/compiler';


@Component({
  selector: 'sd-grid-control',
  templateUrl: './grid-control.component.html',
  styleUrls: [
    '../../assets/css/button.scss',
    '../../assets/css/text.scss',
    '../../assets/css/pagination.scss',
    '../../assets/css/scrollbar.scss',
    '../../assets/css/box.scss',
    '../../assets/css/input.scss',
    '../../assets/css/select.scss',
    './css/button.css',
    './grid-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class GridControlComponent implements AfterViewInit, OnDestroy {
  private handler: IHandlerServer | IHandlerLocal;
  isMobileOrTablet = false;
  displayKey = 'SDCUSTOM';
  gridOption: GridOption;
  orderBy: string;
  orderDirection: 'ASC' | 'DESC';
  localItems: GridItem[] = [];
  items: GridItem[] = [];
  total: number;
  filter: {
    [key: string]: any
  } = {};
  externalFilter: {
    [key: string]: any
  } = {};
  currentPage = 1;
  hiddenPaginate = false;
  inlineExternal: {
    [key: string]: boolean;
  } = {};
  inlineColumn: {
    [key: string]: boolean;
  } = {};
  quickFilters: QuickFilter[] = [];
  selectedQuickFilter: string;
  // Paginate
  pages = [1];
  pageCount = 5;
  totalPage = 1;

  // Loading
  isLoading = false;

  noDataImage: string;
  viewItems: GridItem[] = [];
  sumarize: string;

  fixedColumns: GridColumn[] = [];
  normalColumns: GridColumn[] = [];
  columns: GridColumn[] = [];

  isCheckedAll = false;
  selectedItems: any[] = [];

  @ViewChildren('fixedHeader') private fixedHeaders: QueryList<ElementRef>;
  @ViewChildren('fixedBody') private fixedBodies: QueryList<ElementRef>;
  private fixedHeadersSubcription: Subscription;
  private fixedBodiesSubcription: Subscription;

  @ViewChild('fixedGridContainer') fixedGridContainer: ElementRef;
  @ViewChild('gridFixedBody') gridFixedBody: ElementRef;

  @ViewChild('gridContainer') gridContainer: ElementRef;
  @ViewChild('gridHeader') gridHeader: ElementRef;
  @ViewChild('gridBody') gridBody: ElementRef;

  @ViewChild('sdGridConfig', { static: true }) sdGridConfig: GridConfigComponent;
  @ViewChild('sdGridPopupEditor') sdGridPopupEditor: GridPopupEditorComponent;

  @ViewChild('sdGridPopupFilter') sdGridPopupFilter: GridPopupFilterComponent;
  @ViewChild('matSelect') matSelect: MatSelect;

  @ViewChild('sdGridImportExcel') sdGridImportExcel: GridImportExcelComponent;
  @ViewChild('sdGridPopupExportExcel') sdGridPopupExportExcel: GridPopupExportExcelComponent;
  @Input() set option(value: GridOption) {
    this.setOption(value);
  }
  selectedItem: any = null;
  rowHandler = {
    click: (item: any) => {
      this.selectedItem = item;
      if (this.gridOption.onClickRow) {
        this.gridOption.onClickRow(item);
      }
    },
    dblClick: (item: any) => {
      this.selectedItem = item;
      if (this.gridOption.onDblClickRow) {
        this.gridOption.onDblClickRow(item);
      }
    }
  };

  private setOption = (option: GridOption) => {
    option = this.initConfiguration(option);
    option = this.initTranslate(option);
    delete this.gridOption;
    this.gridOption = option;
    // Loại bỏ những command bị ẩn
    this.gridOption.commands = this.gridOption.commands.filter(command => {
      const hidden = command.hidden;
      if (hidden !== undefined) {
        if (typeof (hidden) === 'boolean') {
          return !hidden;
        } else if (typeof (hidden) === 'function') {
          return !hidden();
        }
      } else {
        return true;
      }
    });
    this.sdGridConfig.setOption({
      key: option.key,
      pageSize: this.gridOption.paginate.pageSize,
      columns: this.gridOption.columns
    });
    this.initExternalFilter();
    this.resize();
    this.detectChanges();
  }

  private initConfiguration = (option: GridOption) => {
    const gridConfiguration = this.configurationService.getGridConfiguration();
    // Filter
    if (!option.filter?.type && gridConfiguration?.filter?.type) {
      if (!option.filter) {
        option.filter = {
          type: gridConfiguration.filter.type
        };
      } else {
        option.filter.type = gridConfiguration.filter.type;
      }
    }
    if (!option.filter?.columnInline && gridConfiguration?.filter?.columnInline) {
      if (!option.filter) {
        option.filter = {
          columnInline: gridConfiguration.filter.columnInline
        };
      } else {
        option.filter.columnInline = gridConfiguration.filter.columnInline;
      }
    }
    if (!option.filter?.quickFilterVisibility && gridConfiguration?.filter?.quickFilterVisibility) {
      if (!option.filter) {
        option.filter = {
          quickFilterVisibility: gridConfiguration.filter.quickFilterVisibility
        };
      } else {
        option.filter.quickFilterVisibility = gridConfiguration.filter.quickFilterVisibility;
      }
    }
    // Translate
    option.translate = option.translate ?? gridConfiguration?.translate;
    switch (option.type) {
      case 'local':
        this.handler = this.handlerLocal;
        break;
      case 'dotnet':
        this.handler = this.handlerDotnet;
        break;
      case 'custom':
        this.handler = option.handlerCustom || gridConfiguration?.handlerCustom;
        if (!this.handler) {
          this.notifyService.notify.warning(`Handler custom was not found`);
          return;
        }
        break;
    }
    return { ...defaultGridOption, ...option };
  }

  private initTranslate = (option: GridOption) => {
    const { translate } = this.translateService;
    option.commands?.forEach(command => {
      if (!option.translate) {
        return;
      }
      if (typeof (command.title) === 'string') {
        command.title = translate(command.title);
      }
      if ('children' in command) {
        command.children?.forEach(childCommand => {
          if (typeof (childCommand.title) === 'string') {
            childCommand.title = translate(childCommand.title);
          }
        });
      }
    });
    option.columns?.forEach(column => {
      if (column.translate === false) {
        return;
      }
      if (option.translate || column.translate) {
        column.title = translate(column.title);
      }
      if (column.type === 'children') {
        column?.children?.forEach(childColumn => {
          if (childColumn.translate === false) {
            return;
          }
          if (option.translate || childColumn.translate) {
            childColumn.title = translate(childColumn.title);
          }
        });
      }
    });
    option.filter?.externalFilters?.forEach(externalFilter => {
      if (option.translate) {
        externalFilter.title = translate(externalFilter.title);
      }
    });
    return option;
  }

  constructor(
    private ref: ChangeDetectorRef,
    deviceService: DeviceDetectorService,
    private handlerLocal: HandlerLocal,
    private handlerDotnet: HandlerDotnet,
    private utilityService: UtilityService,
    private translateService: TranslateService,
    private configurationService: ConfigurationService,
    private datePipe: DatePipe,
    private loadingService: LoadingService,
    private apiService: ApiService,
    private excelService: ExcelService,
    private notifyService: NotifyService,
    private editorVisiblePipe: EditorHandlerPipe) {
    this.noDataImage = this.configurationService.getGridConfiguration()?.noDataImage;
    this.isMobileOrTablet = !deviceService.isDesktop();
    // this.ref.detach();
    // setInterval(() => {
    //   this.ref.markForCheck();
    // }, 1000);
    // ref.detach();
  }

  ngAfterViewInit() {
    this.fixedHeadersSubcription = this.fixedHeaders.changes.subscribe(() => {
      const fixedHeaders = this.fixedHeaders.toArray();
      if (fixedHeaders.length > 0) {
        let left = $(fixedHeaders[0].nativeElement).outerWidth(true);
        for (let i = 1; i < fixedHeaders.length; i++) {
          $(fixedHeaders[i].nativeElement).css({ left });
          left += $(fixedHeaders[i].nativeElement).outerWidth(true);
        }
      }
    });
    this.fixedBodiesSubcription = this.fixedBodies.changes.subscribe(() => {
      const fixedBodies = this.fixedBodies.toArray();
      if (fixedBodies.length > 0) {
        const fixedPerRow = this.fixedBodies.length / this.viewItems.length;
        let left = $(fixedBodies[0].nativeElement).outerWidth(true);
        for (let i = 1; i < fixedBodies.length; i++) {
          if (i % fixedPerRow === 0) {
            left = 0;
          }
          $(fixedBodies[i].nativeElement).css({ left });
          left += $(fixedBodies[i].nativeElement).outerWidth(true);
        }
      }
      const fixedHeaders = this.fixedHeaders.toArray();
      if (fixedHeaders.length > 0) {
        let left = $(fixedHeaders[0].nativeElement).outerWidth(true);
        for (let i = 1; i < fixedHeaders.length; i++) {
          $(fixedHeaders[i].nativeElement).css({ left });
          left += $(fixedHeaders[i].nativeElement).outerWidth(true);
        }
      }
    });
  }

  ngOnDestroy() {
    this.fixedHeadersSubcription?.unsubscribe();
    this.fixedBodiesSubcription?.unsubscribe();
  }

  reload = async (gridItems?: any[]) => {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    try {
      if (this.gridOption.type !== 'local') {
        const handler = this.handler as IHandlerServer;
        const filter = handler.mapRequest(this.getFilterInfo(this.currentPage, this.gridOption.paginate.pageSize));
        if (this.gridOption.method === 'GET') {
          const queryString = Object.keys(filter).filter(key => filter[key] !== null && filter[key] !== undefined)
            .map(key => key + '=' + filter[key]).join('&');
          const url = this.gridOption.url.includes('?') ? `${this.gridOption.url}&${queryString}` : `${this.gridOption.url}?${queryString}`;
          const response = await this.apiService.get(url);
          const { items, total } = handler.mapResponse(response);
          this.items = items;
          this.total = total;
        } else {
          const response = await this.apiService.post(this.gridOption.url, filter);
          const { items, total } = handler.mapResponse(response);
          this.items = items;
          this.total = total;
        }
      } else {
        const handler = this.handler as IHandlerLocal;
        if (typeof (this.gridOption.items) === 'function') {
          if (Array.isArray(gridItems)) {
            this.localItems = gridItems;
          } else {
            const results = this.gridOption.items();
            if (results instanceof Promise) {
              this.localItems = await results;
            } else {
              this.localItems = results;
            }
          }
        } else {
          this.gridOption.items = gridItems || this.gridOption.items;
          this.localItems = this.gridOption.items;
        }
        const response = handler.filter(this.localItems, {
          customFilter: this.gridOption.filter.customFilter,
          rawFilter: this.filter,
          columns: this.gridOption.columns,
          rawExternalFilter: this.externalFilter,
          externalFilters: this.gridOption.filter?.externalFilters,
          orderBy: this.orderBy,
          orderDirection: this.orderDirection,
          pageNumber: this.currentPage,
          pageSize: this.gridOption.paginate.pageSize
        });
        this.items = response.items;
        this.total = response.total;
      }
      this.items.forEach(item => item.originItem = { ...item });
      await this.gridOption?.onReloadCompleted?.(this.items);
      this.generatePaginate();
      this.generateViewItems();
      this.generateEditorHandlers();
      this.generateSumarize();
      this.isLoading = false;
      $(this.gridBody.nativeElement).scrollTop(0);
      if (this.currentPage > 1 && !this.viewItems?.length) {
        if (this.gridOption.type === 'local') {
          if (this.localItems?.length) {
            this.selectPage(1);
            return;
          }
        } else {
          if (this.total > 0) {
            this.selectPage(1);
            return;
          }
        }
      }
      this.detectChanges();
    } catch (error) {
      this.utilityService.handle.error(error);
      this.isLoading = false;
    }
  }

  reloadItem(data: { [id: string]: any }) {
    Object.keys(data).forEach(id => {
      const item = this.items.find(e => !!e.id && e.id === id);
      if (item) {
        this.gridOption.columns.forEach(column => {
          if (item[column.field] !== undefined && data[id][column.field] !== undefined && item[column.field] !== data[id][column.field]) {
            this.blink(item, column.field);
          }
        });
        Object.assign(item, data[id]);
        this.generateEditorHanlder(item);
        this.stopBlink();
      }
    });
  }

  private blink(item: GridItem, field: string) {
    item.blinker = item.blinker || {};
    item.blinker[field] = true;
  }
  private stopBlink() {
    setTimeout(() => {
      this.viewItems.forEach(item => {
        item.blinker = {};
      });
    }, 1500);
  }

  private detectChanges() {
    this.ref.detectChanges();
    this.ref.markForCheck();
  }

  private generateViewItems() {
    this.currentPage = this.currentPage || 1;
    delete this.viewItems;
    if (this.gridOption.type === 'local') {
      this.viewItems = this.items.filter((item, index) => {
        return index >= (this.currentPage - 1) * this.gridOption.paginate.pageSize
          && index < this.currentPage * this.gridOption.paginate.pageSize;
      });
    } else {
      this.viewItems = this.items;
    }
    this.viewItems.forEach(item => {
      item.blinker = item.blinker || {};
      item.subInformation = item.subInformation || {};
    });
  }

  get editedItems() {
    return this.items.filter(item => {
      if (!item.originItem) {
        return true;
      }
      if (Object.keys(item.originItem).some(key => item.originItem[key] !== item[key])) {
        return true;
      }
      return false;
    }).map(item => {
      const { temporary,
        originItem,
        editorHandler,
        editingStatus,
        isChecked,
        subInformation,
        blinker,
        ...result } = item;
      return result;
    });
  }

  selectPage(selectedPage: number | string) {
    if (this.isLoading) {
      return;
    }
    const page = +selectedPage || 1;
    if (this.currentPage !== page && page > 0 && page <= this.totalPage) {
      this.currentPage = page;
      if (this.gridOption.type === 'local') {
        this.reload(this.localItems);
      } else {
        this.reload();
      }
    }
  }

  updateFilter(param?: { filter: any, externalFilter: any }) {
    if (param?.filter) {
      this.filter = param.filter;
    }
    if (param?.externalFilter) {
      this.externalFilter = param.externalFilter;
    }
    if (this.gridOption.type === 'local') {
      this.reload(this.localItems);
    } else {
      this.reload();
    }
  }

  private generatePaginate() {
    const { pageSize } = this.gridOption.paginate;
    if (this.gridOption.type === 'local') {
      this.total = this.items.length;
    }
    this.pages = [];
    this.totalPage = Math.trunc(this.total / pageSize) + (this.total % pageSize === 0 ? 0 : 1);
    if (this.totalPage <= this.pageCount) {
      for (let i = 1; i <= this.totalPage; i++) {
        this.pages.push(i);
      }
    } else {
      if (this.currentPage < 3) {
        this.pages = [1, 2, 3, 4, 5];
      } else if (this.currentPage > this.totalPage - 2) {
        this.pages = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage];
      } else {
        this.pages = [this.currentPage - 2, this.currentPage - 1, this.currentPage, this.currentPage + 1, this.currentPage + 2];
      }
    }
    this.hiddenPaginate = this.currentPage === 1 && this.total <= pageSize;
  }

  private generateSumarize() {
    if (this.items?.length > 0) {
      const from = +this.gridOption.paginate.pageSize * (+this.currentPage - 1) + 1;
      const to = from + this.viewItems.length - 1;
      this.sumarize = `${from} - ${to} / ${this.total}`;
    } else {
      this.sumarize = this.translateService.translate('EMPTY');
    }
  }

  getItems() {
    return this.items;
  }

  //#region Checkable

  private setSelectedItems() {
    this.selectedItems = this.items.filter(item => item.isChecked)
      .map(item => {
        const { temporary,
          originItem,
          editorHandler,
          editingStatus,
          isChecked,
          subInformation,
          blinker,
          ...result } = item;
        return result;
      });
  }

  onCheck = (item: GridItem, isCheckbox?: boolean) => {
    if (!this.gridOption.checkable) {
      return;
    }
    if (!isCheckbox) {
      item.isChecked = !item.isChecked;
    }
    this.isCheckedAll = this.items.length === this.items.filter(e => e.isChecked).length;
    this.gridOption.onCheck?.(this.items.filter(e => e.isChecked), item);
    this.setSelectedItems();
  }

  checkAll(isCheckedAll: boolean) {
    this.isCheckedAll = isCheckedAll;
    this.items.forEach(item => item.isChecked = this.isCheckedAll);
    if (this.gridOption.onCheck) {
      this.gridOption.onCheck(this.items.filter(item => item.isChecked));
    }
    this.setSelectedItems();
  }

  //#endregion

  //#region Sort
  sort = (column: GridColumn) => {
    const sortable = this.gridOption.sortable ?? true;
    const columnSortable = column.sortable ?? true;
    if (!sortable || !columnSortable) {
      return;
    }
    if (this.orderBy === column.field) {
      this.orderDirection = this.orderDirection === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.orderBy = column.field;
      this.orderDirection = 'ASC';
    }
    if (this.gridOption.type === 'local') {
      this.reload(this.localItems);
    } else {
      this.reload();
    }
  }
  //#endregion

  // #region Resize Grid
  private resize() {
    this.detectChanges();
    if (this.gridOption.height) {
      this.gridBody.nativeElement.style.height = this.gridOption.height;
    } else {
      this.gridBody.nativeElement.style.height = `${window.innerHeight - 300}px`;
      setTimeout(() => {
        // Lấy offset top để điều chỉnh kích thước Grid vừa với màn hình
        const top = this.gridBody.nativeElement.getBoundingClientRect().top;
        // const top = $(this.gridBody.nativeElement).offset().top;
        const bottom = this.gridOption.hideFooter ? 0 : (this.isMobileOrTablet ? 45 : 55);
        const height = window.innerHeight - top - bottom;
        this.gridBody.nativeElement.style.height = `${height}px`;
      }, 0);
      setTimeout(() => {
        // Lấy offset top để điều chỉnh kích thước Grid vừa với màn hình
        const top = this.gridBody.nativeElement.getBoundingClientRect().top;
        // const top = $(this.gridBody.nativeElement).offset().top;
        const bottom = this.gridOption.hideFooter ? 0 : (this.isMobileOrTablet ? 45 : 55);
        const height = window.innerHeight - top - bottom;
        this.gridBody.nativeElement.style.height = `${height}px`;
      }, 200);
      setTimeout(() => {
        // Lấy offset top để điều chỉnh kích thước Grid vừa với màn hình
        const top = this.gridBody.nativeElement.getBoundingClientRect().top;
        // const top = $(this.gridBody.nativeElement).offset().top;
        const bottom = this.gridOption.hideFooter ? 0 : (this.isMobileOrTablet ? 45 : 55);
        const height = window.innerHeight - top - bottom;
        this.gridBody.nativeElement.style.height = `${height}px`;
      }, 500);
      setTimeout(() => {
        // Lấy offset top để điều chỉnh kích thước Grid vừa với màn hình
        const top = this.gridBody.nativeElement.getBoundingClientRect().top;
        // const top = $(this.gridBody.nativeElement).offset().top;
        const bottom = this.gridOption.hideFooter ? 0 : (this.isMobileOrTablet ? 45 : 55);
        const height = window.innerHeight - top - bottom;
        this.gridBody.nativeElement.style.height = `${height}px`;
      }, 1000);
    }
  }

  setHeight(height?: string) {
    this.gridOption.height = height;
    this.resize();
  }

  // #endregion

  //#region Import, Export, Config

  loadConfig(configResult: ConfigResult) {
    this.gridOption.paginate.pageSize = configResult.pageSize;
    this.gridOption.columns = configResult.columns;
    this.fixedColumns = configResult.fixedColumns;
    this.normalColumns = configResult.normalColumns;
    this.columns = [...this.fixedColumns, ...this.normalColumns];
    this.currentPage = 1;
    this.initFilter();
    this.initDictionaryColumnValues();
    this.reload();
  }

  private initFilter() {
    this.gridOption.columns.forEach(column => {
      // Gán giá trị filter mặc định cho từng cột
      this.filter[column.field] = this.filter[column.field] ?? '';
    });
  }

  private initDictionaryColumnValues() {
    this.gridOption.columns.forEach(column => {
      if (column.type === 'values') {
        column.dictionary = {};
        if (column.values) {
          column.values.forEach(e => {
            column.dictionary[e.value.toString()] = {
              text: e.text,
              icon: e.icon,
              color: e.color,
              backgroundColor: e.backgroundColor
            };
          });
        }
      }
      if (column.type === 'children') {
        column.children.forEach(childColumn => {
          if (childColumn.type === 'values') {
            childColumn.dictionary = {};
            if (childColumn.values) {
              childColumn.values.forEach(e => {
                childColumn.dictionary[e.value.toString()] = {
                  text: e.text,
                  icon: e.icon,
                  color: e.color,
                  backgroundColor: e.backgroundColor
                };
              });
            }
          }
        });
      }
    });
  }

  //#endregion

  private generateEditorHandlers() {
    this.viewItems.forEach(item => {
      this.generateEditorHanlder(item);
    });
  }

  private generateEditorHanlder(item: GridItem) {
    // item.editorHandler = item.editorHandler || {};
    this.editorVisiblePipe.transform(null, item, this.gridOption);
  }
  trackById(index, item) {
    return item.id;
  }

  get isFiltering() {
    return Object.values(this.filter).some(value => !!value);
  }

  onFilterPopup() {
    const f1 = JSON.stringify(this.filter);
    const f2 = JSON.stringify(this.externalFilter);
    const filter = JSON.parse(f1);
    const externalFilter = JSON.parse(f2);
    this.sdGridPopupFilter.open(this.fixedColumns, this.normalColumns, filter, externalFilter, this.gridOption.filter?.externalFilters);
  }

  clearFilter = () => {
    this.filter = {};
    this.externalFilter = {};
    this.initFilter();
    this.initExternalFilter();
    if (this.sdGridPopupFilter) {
      this.sdGridPopupFilter.filter = this.filter;
      this.sdGridPopupFilter.externalFilter = this.externalFilter;
    }
  }

  onClearFilter = () => {
    this.clearFilter();
    this.reload();
  }

  expandOrCollapse = async (gridItem: GridItem) => {
    const { temporary,
      originItem,
      editorHandler,
      editingStatus,
      isChecked,
      subInformation,
      ...item } = gridItem;
    if (!this.gridOption.subInformation) {
      return;
    }
    if (gridItem.subInformation?.isOpened) {
      gridItem.subInformation.isOpened = false;
      return;
    }
    if (this.gridOption.subInformation.lazyLoading && !gridItem.subInformation?.isLoaded) {
      gridItem.subInformation.isLoading = true;
      try {
        gridItem.subInformation.subItems = await this.gridOption.subInformation.onLoad(item);
        if (!Array.isArray(gridItem.subInformation.subItems)) {
          this.notifyService.alert.warning(`Data is not an array`);
          gridItem.subInformation.subItems = [];
        }
        gridItem.subInformation.isLoading = false;
        gridItem.subInformation.isLoaded = true;
        gridItem.subInformation.isOpened = true;
        this.ref.detectChanges();
      } catch (err) {
        this.utilityService.handle.error(err);
        gridItem.subInformation.isLoading = false;
        this.ref.detectChanges();
      }
      return;
    }
    if (this.gridOption.subInformation.lazyLoading === false && !gridItem.subInformation.isLoaded) {
      gridItem.subInformation.subItems = gridItem[this.gridOption.subInformation.field];
      if (!Array.isArray(gridItem.subInformation.subItems)) {
        this.notifyService.alert.warning(`Data is not an array`);
        gridItem.subInformation.subItems = [];
      }
      gridItem.subInformation.isLoaded = true;
      gridItem.subInformation.isOpened = true;
      return;
    }
    gridItem.subInformation.isOpened = true;
    this.ref.detectChanges();
  }
  //#region Editable
  onCreate = () => {
    const { editor } = this.gridOption;
    if (!editor) {
      return;
    }
    if (!editor?.addable) {
      return;
    }
    const item: GridItem = {
      editingStatus: 'create', // Đánh dấu item được tạo mới
      blinker: {},
      subInformation: {}
    };
    // Gán giá trị mặc định
    this.gridOption.columns.forEach(column => {
      if (column.type === 'values') {
        item[column.field] = '';
      } else if (column.type === 'bool') {
        item[column.field] = true;
      } else if (column.type === 'number') {
        item[column.field] = 0;
      }
    });
    editor.onAdd?.(item);

    // Đưa item lên dòng đầu tiên nếu type khác popup
    if (editor.type !== 'popup') {
      if (this.gridOption.type === 'local') {
        this.items.splice(0, 0, item);
      }
      this.viewItems.splice(0, 0, item);
    }
    this.onUpdate(item);
  }
  onUpdate = (item: GridItem) => {
    const { editor } = this.gridOption;
    item.editingStatus = item.editingStatus || 'update';
    item.temporary = { ...item };
    this.generateEditorHanlder(item);
    if (editor.type === 'popup') {
      this.sdGridPopupEditor.open(item);
    }
  }
  onSave = async (item: GridItem) => {
    const { editor } = this.gridOption;
    try {
      item.editorHandler.saving = true;
      if (editor.validate) {
        const result = editor.validate(item);
        if (result instanceof Promise) {
          const message = await result;
          if (message) {
            throw message;
          }
        } else {
          if (result) {
            throw result;
          }
        }
      }
      if (editor.onSave) {
        const result = editor.onSave(item);
        if (result instanceof Promise) {
          await result;
        }
      }

      if (item.editingStatus === 'create' && editor.type === 'popup') {
        if (this.gridOption.type === 'local') {
          this.items.splice(0, 0, item);
        }
        this.viewItems.splice(0, 0, item);
      }

      item.editingStatus = undefined;
      this.generateEditorHanlder(item);
    } catch (err) {
      this.notifyService.notify.warning(err);
    } finally {
      item.editorHandler.saving = false;
      this.ref.detectChanges();
    }
  }

  onCancel = (item: GridItem) => {
    const { editor } = this.gridOption;
    if (item.editingStatus === 'create') {
      if (editor.type !== 'popup') {
        if (this.gridOption.type === 'local') {
          this.items.splice(0, 1);
        }
        this.viewItems.splice(0, 1);
      }
    } else {
      Object.assign(item, item.temporary);
      item.editingStatus = undefined;
      this.generateEditorHanlder(item);
      this.ref.detectChanges();
    }
  }

  private initExternalFilter = () => {
    if (this.gridOption.filter?.externalFilters?.length) {
      this.gridOption.filter.externalFilters.forEach(externalFilter => {
        if (externalFilter.type === 'string') {
          if (externalFilter.default) {
            this.externalFilter[externalFilter.field] = externalFilter.default ?? '';
          }
          return;
        }
        if (externalFilter.type === 'number') {
          if (externalFilter.default) {
            this.externalFilter[externalFilter.field] = externalFilter.default ?? undefined;
          }
          return;
        }
        if (externalFilter.type === 'daterange') {
          this.externalFilter[externalFilter.field] = {
            from: externalFilter.defaultFrom ?? undefined,
            to: externalFilter.defaultTo ?? undefined
          };
          return;
        }
        if (externalFilter.type === 'numberrange') {
          this.externalFilter[externalFilter.field] = {
            from: externalFilter.defaultFrom ?? undefined,
            to: externalFilter.defaultTo ?? undefined
          };
          return;
        }
        if (externalFilter.type === 'daterangefull') {
          this.externalFilter[externalFilter.field] = {
            from: externalFilter.defaultFrom ?? undefined,
            to: externalFilter.defaultTo ?? undefined
          };
          return;
        }
      });
    }
  }

  //#endregion

  onSearch = (searchValue: string, item: GridItem, column: GridColumn) => {
    item[column.field] = searchValue;
  }

  onFilterConfigurationLoaded = (param: FilterConfiguration) => {
    this.quickFilters = param.quickFilters || [];
    this.selectedQuickFilter = param.selectedQuickFilter || '';
    if (this.selectedQuickFilter) {
      const quickFilter = this.quickFilters.find(e => e.code === this.selectedQuickFilter);
      if (quickFilter) {
        const f1 = JSON.stringify(quickFilter.filter);
        const f2 = JSON.stringify(quickFilter.externalFilter);
        this.filter = JSON.parse(f1);
        this.externalFilter = this.refreshExternalFilter(this.gridOption?.filter?.externalFilters, JSON.parse(f2));
      }
    }
    this.inlineExternal = param.inlineExternal || {};
    this.inlineColumn = param.inlineColumn || {};
    this.resize();
  }

  onSelectQuickFilter = (event: MatSelectChange) => {
    const quickFilter = this.quickFilters.find(e => e.code === event.value);
    if (quickFilter?.code) {
      const f1 = JSON.stringify(quickFilter.filter);
      const f2 = JSON.stringify(quickFilter.externalFilter);
      this.selectedQuickFilter = quickFilter?.code;
      this.filter = JSON.parse(f1);
      this.externalFilter = this.refreshExternalFilter(this.gridOption?.filter?.externalFilters, JSON.parse(f2));
      this.updateFilter();
    } else {
      this.selectedQuickFilter = '';
      this.onClearFilter();
    }
    this.sdGridPopupFilter?.updateConfiguration(this.selectedQuickFilter);
  }

  private getExportItems = async () => {
    if (this.isLoading) {
      return;
    }
    const pageNumber = 1;
    const pageSize = 10000;
    this.isLoading = true;
    try {
      if (this.gridOption.type !== 'local') {
        const handler = this.handler as IHandlerServer;
        const filter = handler.mapRequest(this.getFilterInfo(pageNumber, pageSize));
        if (this.gridOption.method === 'GET') {
          const queryString = Object.keys(filter).filter(key => filter[key] !== null && filter[key] !== undefined)
            .map(key => key + '=' + filter[key]).join('&');
          const url = this.gridOption.url.includes('?') ? `${this.gridOption.url}&${queryString}` : `${this.gridOption.url}?${queryString}`;
          const response = await this.apiService.get(url);
          return handler.mapResponse(response).items;
        } else {
          const response = await this.apiService.post(this.gridOption.url, filter);
          return handler.mapResponse(response).items;
        }
      } else {
        let localItems = [];
        const handler = this.handler as IHandlerLocal;
        if (typeof (this.gridOption.items) === 'function') {
          const results = this.gridOption.items();
          if (results instanceof Promise) {
            localItems = await results;
          } else {
            localItems = results;
          }
        } else {
          localItems = this.gridOption.items;
        }
        const response = handler.filter(localItems, {
          customFilter: this.gridOption.filter.customFilter,
          rawFilter: this.filter,
          columns: this.gridOption.columns,
          rawExternalFilter: this.externalFilter,
          externalFilters: this.gridOption.filter?.externalFilters,
          orderBy: this.orderBy,
          orderDirection: this.orderDirection,
          pageNumber,
          pageSize
        });
        return response.items;
      }
    } catch (error) {
      this.utilityService.handle.error(error);
    } finally {
      this.isLoading = false;
      this.ref.detectChanges();
    }
  }

  private getFilterInfo = (pageNumber: number, pageSize: number): FilterInfo => {
    for (const key of Object.keys(this.filter)) {
      if (typeof (this.filter[key]) === 'string') {
        this.filter[key] = this.filter[key].trim();
      }
    }
    for (const key of Object.keys(this.externalFilter)) {
      if (typeof (this.externalFilter[key]) === 'string') {
        this.externalFilter[key] = this.externalFilter[key].trim();
      }
    }
    return {
      customFilter: this.gridOption.filter.customFilter,
      rawFilter: this.filter,
      columns: this.gridOption.columns,
      rawExternalFilter: this.externalFilter,
      externalFilters: this.gridOption.filter?.externalFilters,
      orderBy: this.orderBy,
      orderDirection: this.orderDirection,
      pageNumber,
      pageSize
    };
  }

  onExportByTemplate = async (params: { excelConfig: ExcelConfig, excelColumns: ExcelTempateColumn[] }) => {
    this.loadingService.start();
    let exportItems = [];
    if (this.gridOption.export?.items) {
      exportItems = await this.gridOption.export?.items(this.getFilterInfo(1, 10000)).finally(this.loadingService.stop);
    } else {
      exportItems = await this.getExportItems().finally(this.loadingService.stop);
    }
    if (this.gridOption.export?.mapping) {
      const results = this.gridOption.export.mapping(exportItems, params.excelConfig.name);
      if (results instanceof Promise) {
        exportItems = await results;
      } else {
        exportItems = results;
      }
    }
    const columns = [...this.gridOption.columns, ...(this.gridOption.export?.columns || [])];
    const items = exportItems.map(item => {
      const obj: any = {};
      const handle = (column: GridColumn) => {
        if (column.type === 'children') {
          column.children.forEach(handle);
        } else if (column.transform) {
          obj[column.field] = column.transform(item[column.field], item);
        } else if (item[column.field] === undefined || item[column.field] === null || item[column.field] === '') {
          obj[column.field] = '';
        } else if (column.type === 'string' || column.type === 'number' || column.type === 'color') {
          // Nếu cell là string hoặc number thì gán bằng chính nó
          obj[column.field] = item[column.field];
        } else if (column.type === 'bool') {
          // Nếu là bool thì gán bằng giá trị trueValue và falseValue (nếu có), mặc định là TRUE/FALSE
          if (item[column.field]) {
            obj[column.field] = column.trueValue || 'True';
          } else {
            obj[column.field] = column.falseValue || 'False';
          }
        } else if (column.type === 'date') {
          // Nếu là date thì convert theo đúng format
          const date = new Date(item[column.field]);
          obj[column.field] = this.datePipe.transform(date, 'dd/MM/yyyy');
        } else if (column.type === 'datetime') {
          // Nếu là datetime thì convert theo đúng format
          const date = new Date(item[column.field]);
          obj[column.field] = this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss');
        } else if (column.type === 'time') {
          // Nếu là time thì convert theo đúng format
          const date = new Date(item[column.field]);
          obj[column.field] = this.datePipe.transform(date, 'HH:mm:ss');
        } else if (column.type === 'values') {
          // Nếu là values thì lấy giá trị của value được chọn
          const data = column.values.find(e => e.value === item[column.field]);
          if (data) {
            obj[column.field] = data.text;
          } else {
            obj[column.field] = item[column.field];
          }
        } else if (column.type === 'radio') {
          const data = column.values.find(e => e[column.valueField] === item[column.field]);
          if (data) {
            obj[column.field] = data[column.displayField];
          } else {
            obj[column.field] = item[column.field];
          }
        }
      };
      columns.forEach(handle);
      return obj;
    });
    this.excelService.generateExcelDataByTemplate(params.excelConfig.fullPath, params.excelColumns, items, params.excelConfig.name);
  }

  get invalidItems() {
    return this.items.filter(e => e.editorHandler?.errorMessage).map(e => {
      const { temporary,
        originItem,
        editorHandler,
        editingStatus,
        isChecked,
        subInformation,
        blinker,
        ...item } = e;
      return {
        item,
        message: e.editorHandler.errorMessage
      };
    });
  }

  get gridItems() {
    return this.items.map(e => {
      const { temporary,
        originItem,
        editorHandler,
        editingStatus,
        isChecked,
        subInformation,
        blinker,
        ...item } = e;
      return item;
    });
  }

  onEditorChange = () => {
    this.ref.detectChanges();
  }
  onSelectPageSize = () => {
    this.reload();
  }
  private refreshExternalFilter = (externalFilters: GridExternalFilter[], externalFilter: any) => {
    externalFilter = externalFilter || {};
    externalFilters = externalFilters || [];
    externalFilters.forEach(e => {
      if (e.type === 'string') {
        if (e.default) {
          externalFilter[e.field] = e.default ?? '';
        }
        return;
      }
      if (e.type === 'number') {
        externalFilter[e.field] = externalFilter[e.field] ?? e.default ?? undefined;
        return;
      }
      if (e.type === 'daterange') {
        externalFilter[e.field] = {
          from: externalFilter[e.field]?.from ?? e.defaultFrom ?? undefined,
          to: externalFilter[e.field]?.to ?? e.defaultTo ?? undefined
        };
        return;
      }
      if (e.type === 'numberrange') {
        externalFilter[e.field] = {
          from: externalFilter[e.field]?.from ?? e.defaultFrom ?? undefined,
          to: externalFilter[e.field]?.to ?? e.defaultTo ?? undefined
        };
        return;
      }
      if (e.type === 'daterangefull') {
        externalFilter[e.field] = {
          from: externalFilter[e.field]?.from ?? e.defaultFrom ?? undefined,
          to: externalFilter[e.field]?.to ?? e.defaultTo ?? undefined
        };
        return;
      }
    });
    return externalFilter;
  }

  onCreateQuickFilter = (ev?: Event) => {
    this.matSelect.close();
    this.onFilterPopup();
    this.sdGridPopupFilter.close();
    this.sdGridPopupFilter?.onCreateQuickFilter(ev);
  }

  onEditQuickFilter = (ev: Event, quickFilter?: QuickFilter) => {
    this.matSelect.close();
    this.onFilterPopup();
    this.sdGridPopupFilter.close();
    this.sdGridPopupFilter?.onEditQuickFilter(ev, quickFilter);
  }

  onDeleteQuickFilter = (ev: Event, quickFilter?: QuickFilter) => {
    this.matSelect.close();
    this.onFilterPopup();
    this.sdGridPopupFilter.close();
    this.sdGridPopupFilter?.onDeleteQuickFilter(ev, quickFilter);
  }
}
